<template>
<div class="card">
    <img v-if="company == 'welion'" src="../assets/welion.png">
    <img v-else src="../assets/generali.svg">
    <Button :msg="message" @click.native="openModal('chiudere')"/>
    <Button style="margin-top: 20px" :msg="messageOpen" @click.native="openModal('riaprire')"/>
</div>
</template>

<script>
import Button from '@/components/Button.vue'
export default {
    props: ['company'],
    components: {
        Button
    },
    computed: {
        message() {
            return `Chiudi tutte le linee di ${this.company}`
        },
        messageOpen(){
            return `Riapri tutte le linee di ${this.company}`
        }
    },
    methods: {
        openModal(msg){
            this.$emit('openModal', msg)
        }
    }
}
</script>

<style scoped>
    img{
        height: 300px;
        width: 80%;
    }
    .card{
        display: flex;
        flex-direction: column;
        border: 1px solid grey;
        height: 500px;
        width: 20%;
        min-width: 370px;
        align-items: center;
        margin-top: 100px;
    }
</style>
